export enum COLOR_FAMILY {
    BERRY = 'berry_color',
    BLUE = 'blue_color',
    BROWN = 'brown_color',
    BEIGE = 'beige_color',
    DARK = 'dark_color',
    DEEP = 'deep_color',
    FAIR = 'fair_color',
    GREEN = 'green_color',
    GREY = 'grey_color',
    LIGHT = 'light_color',
    MEDIUM = 'medium_color',
    MEDIUM_FAIR = 'medium_fair_color',
    MODERATE = 'moderate_color',
    NUDE = 'nude_color',
    ORANGE = 'orange_color',
    OTHER = 'other_color',
    PINK = 'pink_color',
    PURPLE = 'purple_color',
    RED = 'red_color',
    VERY_FAIR = 'very_fair_color',
    VIOLET = 'violet_color',
    YELLOW = 'yellow_color'
}
